<div class="box" [ngClass]="{ 'box-success': success, 'box-error': !success }">
  <mat-icon class="indicator-icon">{{ success ? 'check_circle' : 'cancel' }}</mat-icon
  ><ng-content select="[content]"></ng-content>
</div>
 